import Angular from "angular";
import Template from "./split-view.html";
import Controller from "./split-view.controller";

export default Angular.module('split-view', ['matchMedia'])
    .component('splitView', {
        template: Template,
        controller: Controller,
        transclude: {
            'splitViewLeft': '?splitViewLeft',
            'splitViewRight': '?splitViewRight'
        },
        bindings: {
            viewLeftOpen: '<',
            viewRightOpen: '<'
        }
    })



// WEBPACK FOOTER //
// ./src/modules/core/components/split-view/split-view.js